export const ClientErrors = {
  BAD_USER_INPUT: "BAD_USER_INPUT",
  USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const displayError = (error: any) => {
  const code = error?.extensions?.code;

  switch (code) {
    case ClientErrors.BAD_USER_INPUT:
      return (
        error?.extensions?.validationErrors?.[0]?.message || "Bad user input"
      );
    case ClientErrors.USER_ALREADY_EXISTS:
      return "User already exists";
    default:
      return error?.message || "An unknown error occurred";
  }
};
